// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/styles/" + chunkId + "." + {"1734": "851b1376c9844db7","2989": "6a63802a54d0be01",}[chunkId] + ".css"
}